import React, { useContext } from 'react';
import { selectUlogovan, selectRole, selectUsername, selectRoute, selectRouteSimple } from '../redux/selectors';
import { connect } from 'react-redux';
import { actionRoute } from "../redux/actions";
import SidebarOption from './SidebarOption';
import RenderIfTrue from './RenderIfTrue';
import SidebarOptionTree from './SidebarOptionTree';
import { SastavljacContext } from './AppSastavljac';


const SidebarMenu = (props) => {
  const dispatch = props.dispatch;
  const tokData = useContext(SastavljacContext);
  const modeAdminPanel = props.modeAdminPanel;
  const {
    comorditemCurrent_is_read_only,
    is_virbom_saved,
    comorderCurrent_id,
  } = tokData;

  let _is_strana_narudzbe_disabled = false;
  let _is_strana_editor_disabled = false;
  if (is_virbom_saved !== true && comorditemCurrent_is_read_only !== true) {
    // ako izemene comorditema nisu sacuvane i nije readonly mode
    _is_strana_narudzbe_disabled = true;
  }
  if (comorderCurrent_id > 0) {
  } else {
    _is_strana_editor_disabled = true;
  }

  const active = props.routeSimple.route;
  let activeOptionTree = false;
  if (props.routeSimple.menuOptionTree) {
    activeOptionTree = props.routeSimple.menuOptionTree;
  }
  const ulogovan = props.ulogovan;
  const role = props.role;
  const username = props.username;

  let cl = 'sidebar';

  if (ulogovan) {
    // ako smo ulogovani
    cl += ' mode-loggedin';
    if (role === "ADMIN") {
      //
    } else {
      //
    }
  } else {
    // ako nismo ulogovani
    cl += ' mode-guest';
  }

  let clicked = (what) => {
    return () => {
      dispatch(actionRoute(what))
    };
  }

  return (
    <div className="sidebar-menu">
      <RenderIfTrue condition={modeAdminPanel !== true}>
        <h3 className="admin-only-NOT">Radni panel</h3>
        <div className="options-group admin-only-NOT">


          <RenderIfTrue condition={false}>
            <SidebarOption
              title={'Admin Panel'}
              active={active === 'HOME'}
              handleClick={clicked('HOME')}
            />
            <SidebarOption
              title={'Primeri tabela'}
              active={active === 'PRIMERI'}
              handleClick={clicked('PRIMERI')}
            />
            <SidebarOption
              title={'Dizajniraj'}
              active={active === 'DIZAJNIRAJ'}
              handleClick={clicked('DIZAJNIRAJ')}
            />
            <SidebarOption
              title={'Primer hijerarhije'}
              active={active === 'PRIMER_HIJERARHIJE'}
              handleClick={clicked('PRIMER_HIJERARHIJE')}
            />
            <SidebarOption
              title={'Scenario 1'}
              active={active === 'SCENARIO_1'}
              handleClick={clicked('SCENARIO_1')}
            />
            <SidebarOption
              title={'Scenario 2'}
              active={active === 'SCENARIO_2'}
              handleClick={clicked('SCENARIO_2')}
            />
            <SidebarOption
              title={'Editor v1'}
              active={active === 'EDITOR_V1'}
              handleClick={clicked('EDITOR_V1')}
            />
          </RenderIfTrue>

          <RenderIfTrue condition={props.ulogovan === true}>
            <SidebarOption
              title={'Narudžbe'}
              active={active === 'TER_NARUDZBE'}
              handleClick={clicked('TER_NARUDZBE')}
              i="fa fa-usd"
              disabled={_is_strana_narudzbe_disabled}
            />
            <SidebarOption
              title={'T. Priprema'}
              active={active === 'EDITOR'}
              handleClick={clicked('EDITOR')}
              i="fa fa-pencil-square-o"
              disabled={_is_strana_editor_disabled}
            />
            <SidebarOption
              title={'Export sastavnice'}
              active={active === 'EXPORT'}
              handleClick={clicked('EXPORT')}
              i="fa fa-th"
              disabled={_is_strana_editor_disabled}
            />
            <SidebarOption
              title={'Export CNC MES'}
              active={active === 'EXPORT_CNC'}
              handleClick={clicked('EXPORT_CNC')}
              i="fa fa-file-archive-o"
            />

            <SidebarOptionTree
              title="Biblioteka"
              active={activeOptionTree === 'BIBLIOTEKA_GROUP'}
            >
              <SidebarOption
                title={'Biblioteka genusa'}
                active={active === 'BIBLIOTEKA'}
                handleClick={clicked('BIBLIOTEKA')}
                i="fa fa-book"
              />
              <SidebarOption
                title={'Biblioteka param.'}
                active={active === 'BIBLIOTEKA_PARAMETARA'}
                handleClick={clicked('BIBLIOTEKA_PARAMETARA')}
                i="fa fa-book"
              />
              <SidebarOption
                title={'Biblioteka polja'}
                active={active === 'BIBLIOTEKA_POLJA'}
                handleClick={clicked('BIBLIOTEKA_POLJA')}
                i="fa fa-book"
              />
            </SidebarOptionTree>

            <RenderIfTrue condition={false}>
              <SidebarOption
                title={'Import'}
                active={active === 'IMPORT'}
                handleClick={clicked('IMPORT')}
                i="fa fa-circle-thin"
              />
            </RenderIfTrue>
          </RenderIfTrue>
        </div>
      </RenderIfTrue>

      <RenderIfTrue condition={modeAdminPanel !== true}>
        <h3 className="">Dokumentacija</h3>
        <div className="options-group">
          <SidebarOptionTree
            title="Dokumentacija"
            active={activeOptionTree === 'DOKUMENTACIJA_GROUP'}
          >
            <SidebarOption
              title={'Uputstvo'}
              active={active === 'DOKUMENTACIJA_UPUTSTVO'}
              handleClick={clicked('DOKUMENTACIJA_UPUTSTVO')}
              i="fa fa-question-circle"
            />
            <SidebarOption
              title={'Dokumentacija'}
              active={active === 'DOKUMENTACIJA'}
              handleClick={clicked('DOKUMENTACIJA')}
              i="fa fa-question-circle"
            />
            <SidebarOption
              title={'U razvoju'}
              active={active === 'DOKUMENTACIJA_U_RAZVOJU'}
              handleClick={clicked('DOKUMENTACIJA_U_RAZVOJU')}
              i="fa fa-question-circle"
            />
            <SidebarOption
              title={'Dokumentacija Termovent'}
              active={active === 'DOKUMENTACIJA_TERMOVENT'}
              handleClick={clicked('DOKUMENTACIJA_TERMOVENT')}
              i="fa fa-question-circle"
            />
            <SidebarOption
              title={'Standardi'}
              active={active === 'DOCS_STANDARDI'}
              handleClick={clicked('DOCS_STANDARDI')}
              i="fa fa-question-circle"
            />
            <SidebarOption
              title={'Testiranje'}
              active={active === 'DOKUMENTACIJA_TESTIRANJE'}
              handleClick={clicked('DOKUMENTACIJA_TESTIRANJE')}
              i="fa fa-question-circle"
            />
          </SidebarOptionTree>
        </div>
      </RenderIfTrue>

      <RenderIfTrue condition={role === 'DEV' && modeAdminPanel !== true}>
        <h3 className="">Ostalo</h3>
        <div className="options-group">
          <SidebarOptionTree
            title="Prezentacije"
            active={activeOptionTree === 'PREZENTACIJA_GROUP'}
          >
            {/*
          <SidebarOption
            title={'Prezentacija 2022'}
            active={active === 'PREZENTACIJA2022'}
            handleClick={clicked('PREZENTACIJA2022')}
            i="fa fa-circle-thin"
          />
          */}
            <SidebarOption
              title={'Prezentacija'}
              active={active === 'PREZENTACIJA'}
              handleClick={clicked('PREZENTACIJA')}
              i="fa fa-circle-thin"
            />
            <SidebarOption
              title={'Prezentacija 2'}
              active={active === 'PREZENTACIJA2'}
              handleClick={clicked('PREZENTACIJA2')}
              i="fa fa-circle-thin"
            />
          </SidebarOptionTree>
          <SidebarOption
            title={'Plan'}
            active={active === 'PLAN'}
            handleClick={clicked('PLAN')}
            i="fa fa-circle-thin"
          />
        </div>
      </RenderIfTrue>

      <RenderIfTrue condition={true}>
        <h3 className="">Admin panel</h3>
        <div className="options-group">
          <SidebarOption
            title={'Admin panel'}
            active={active === 'ADMIN_PANEL'}
            handleClick={clicked('ADMIN_PANEL')}
            i="fa fa-shield"
          />
        </div>
        <RenderIfTrue condition={true && modeAdminPanel === true}>
          <div className="options-group">
            <SidebarOption
              title={'Admin korisnici'}
              active={active === 'ADMIN_USERS'}
              handleClick={clicked('ADMIN_USERS')}
              i="fa fa-users"
            />
            <SidebarOption
              title={'Admin narudžbe'}
              active={active === 'ADMIN_TER_COMORDER'}
              handleClick={clicked('ADMIN_TER_COMORDER')}
              i="fa fa-shield"
            />
            <SidebarOption
              title={'Admin stavke nar.'}
              active={active === 'ADMIN_TER_COMORDITEM'}
              handleClick={clicked('ADMIN_TER_COMORDITEM')}
              i="fa fa-shield"
            />
          </div>
          <h3 className="">Biblioteke</h3>
          <div className="options-group">
            <SidebarOption
              title={'Admin cparams'}
              active={active === 'ADMIN_LIB_CPARAMS'}
              handleClick={clicked('ADMIN_LIB_CPARAMS')}
              i="fa fa-shield"
            />
            <SidebarOption
              title={'Admin Virtel Params.'}
              active={active === 'ADMIN_LIB_VIRTEL_PARAMS'}
              handleClick={clicked('ADMIN_LIB_VIRTEL_PARAMS')}
              i="fa fa-shield"
            />
            <SidebarOption
              title={'Admin Materijal'}
              active={active === 'ADMIN_LIB_MATERIJAL_LIM'}
              handleClick={clicked('ADMIN_LIB_MATERIJAL_LIM')}
              i="fa fa-shield"
            />
            <SidebarOption
              title={'Admin CNC prog.'}
              active={active === 'ADMIN_LIB_CNC_S4_TEMPLATE'}
              handleClick={clicked('ADMIN_LIB_CNC_S4_TEMPLATE')}
              i="fa fa-shield"
            />
            <SidebarOption
              title={'Admin Bibl. Tabela'}
              active={active === 'ADMIN_LIB_DOCUMENT'}
              handleClick={clicked('ADMIN_LIB_DOCUMENT')}
              i="fa fa-shield"
            />
          </div>
          <h3 className="">* U izradi</h3>
          <div className="options-group">
            <SidebarOption
              title={'Admin Ter. Konstanta'}
              active={active === 'ADMIN_LIB_TER_CONST'}
              handleClick={clicked('ADMIN_LIB_TER_CONST')}
              i="fa fa-shield"
            />
            <SidebarOption
              title={'Admin Dinamička F.'}
              active={active === 'ADMIN_DINAMICKAF'}
              handleClick={clicked('ADMIN_DINAMICKAF')}
              i="fa fa-shield"
            />
            <SidebarOption
              title={'Admin Radni Centri'}
              active={active === 'ADMIN_RADNICENTRI'}
              handleClick={clicked('ADMIN_RADNICENTRI')}
              i="fa fa-shield"
            />
            <SidebarOption
              title={'* Temp. Optimizacije'}
              active={active === 'TEMP_CNC_OPTIMIZACIJE'}
              handleClick={clicked('TEMP_CNC_OPTIMIZACIJE')}
              i="fa fa-scissors"
            />
          </div>
        </RenderIfTrue>
      </RenderIfTrue>

      {/* <RenderIfTrue condition={props.ulogovan === true && (props.role === 'DEV' || props.role === 'ADMIN')}> */}
      <RenderIfTrue condition={true && modeAdminPanel !== true}>
        <h3 className="">Dev</h3>
        <div className="options-group">
          <SidebarOption
            title={'Dev panel'}
            active={active === 'DEVPANEL'}
            handleClick={clicked('DEVPANEL')}
            i="fa fa-shield"
          />
        </div>
        <div className="options-group">
          <SidebarOption
            title={'Import/Export ostalo...'}
            active={active === 'IMPORTOSTALO'}
            handleClick={clicked('IMPORTOSTALO')}
            i="fa fa-circle-thin"
          />
        </div>
      </RenderIfTrue>

      <RenderIfTrue condition={role === 'DEV' && modeAdminPanel !== true}>
        <h3 className="">Dev ONLY</h3>
        <div className="options-group">
          <SidebarOption
            title={'Primeri tabela'}
            active={active === 'PRIMERI'}
            handleClick={clicked('PRIMERI')}
          />
        </div>
      </RenderIfTrue>

    </div >

  );
}

function mapStateToProps(state) {
  return {
    routeSimple: selectRouteSimple(state),
    ulogovan: selectUlogovan(state),
    role: selectRole(state),
    username: selectUsername(state)
  };
}
export default connect(mapStateToProps)(SidebarMenu);
